import QTable from 'quasar/src/components/table/QTable.js';

export function getFaqColumnsInAdmin(): QTable['columns'] {
  return [
    /*    {
          name: 'id',
          field: 'id',
          label: 'شماره سوال',
          align: 'left'
        },*/
    {
      name: 'question',
      field: 'question',
      label: 'پرسش',
      align: 'left',
      style: 'max-width:200px'
    },
    {
      name: 'answer',
      field: 'answer',
      label: 'پاسخ',
      align: 'left',
      style: 'max-width:250px'
    },
    {
      name: 'type',
      field: 'type',
      label: 'نوع',
      align: 'left'
    },
    {
      name: 'actions',
      field: 'actions',
      label: 'عملیات',
      align: 'center'
    }]
}


